<template>
    <div class="user-tab-panel">
        <v-row>
            <v-col cols="12">
                <v-select
                    v-model="payload.role"
                    label="Tipo de usuário"
                    outlined
                    hide-details="auto"
                    item-text="text"
                    item-value="value"
                    disabled
                    :items="$user.roles"
                />
            </v-col>

            <v-col cols="12">
                <v-text-field
                    autocomplete="nope"
                    v-model="payload.name"
                    label="Nome"
                    outlined
                    hide-details="auto"
                />
            </v-col>

            <v-col cols="12">
                <v-text-field
                    autocomplete="nope"
                    v-model="payload.email"
                    label="E-mail"
                    outlined
                    hide-details="auto"
                />
            </v-col>

            <v-col
                cols="12"
                v-if="['user', 'partner'].includes(payload.role)"
            >
                <v-autocomplete
                    multiple
                    v-model="payload.permissions"
                    label="Permissões"
                    outlined
                    hide-details="auto"
                    item-text="name"
                    item-value="id"
                    :items="$user.permissions"
                />
            </v-col>

            <template v-if="payload.role === 'user'">
                <v-col v-if="payload.permissions?.includes('GEO_SEO_PRESENCE') && $store.state.currentUser?.role === 'admin'" cols="12">
                    <v-text-field v-model.number="payload.geo_seo_prompt_limit" type="number" min="1" step="1"
                        label="Limite de prompts ativos — Presença GEO e SEO" outlined hide-details="auto"
                        hint="Pause prompts antes de reduzir a cota abaixo da quantidade ativa." persistent-hint />
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        autocomplete="nope"
                        type="number"
                        v-model="payload.articles_quantity"
                        label="Saldo de artigos"
                        outlined
                        hide-details="auto"
                    />
                </v-col>

                <v-col
                    cols="12"
                    v-if="payload.permissions?.includes('SOCIAL_NETWORK_ASSISTANT')"
                >
                    <v-text-field
                        autocomplete="nope"
                        type="number"
                        v-model="payload.social_post_quantity"
                        label="Saldo de postagens sociais"
                        outlined
                        hide-details="auto"
                    />
                </v-col>

                <v-col cols="12">
                    <r-server-autocomplete
                        v-model="payload.vindi_customer_id"
                        autocomplete="nope"
                        label="Cliente Vindi"
                        outlined
                        hide-details="auto"
                        request="searchVindiCustomers"
                        initial-value-request="getVindiCustomerById"
                        item-text="email"
                        item-value="id"
                        clearable
                    >
                        <template #selection="{ item, attrs }">
                            <v-list-item-content v-bind="attrs">
                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                                <v-list-item-subtitle>ID: {{ item.id }} - Email: {{ item.email }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                        <template #item="{ item, attrs }">
                            <v-list-item-content v-bind="attrs">
                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                                <v-list-item-subtitle>ID: {{ item.id }} - Email: {{ item.email }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </r-server-autocomplete>
                </v-col>

                <v-col cols="12">
                    <v-text-field
                        autocomplete="nope"
                        v-model="payload.vindi_subscription_id"
                        label="ID Assinatura Vindi"
                        readonly
                        outlined
                        hide-details="auto"
                    />
                </v-col>
                <v-col cols="12">
                    <v-autocomplete
                        v-model="payload.vindi_subscription_id"
                        :items="subscriptions"
                        label="Atribuir Assinatura Vindi"
                        outlined
                        hide-details="auto"
                        item-text="customer.email"
                        item-value="id"
                    >
                        <template #selection="{ item, attrs }">
                            <v-list-item-content v-bind="attrs">
                                <v-list-item-title>{{ item.customer.email }}</v-list-item-title>
                                <v-list-item-subtitle>ID: {{ item.id }} - Plano: {{ item.plan.name }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                        <template #item="{ item, attrs }">
                            <v-list-item-content v-bind="attrs">
                                <v-list-item-title>{{ item.customer.email }}</v-list-item-title>
                                <v-list-item-subtitle>ID: {{ item.id }} - Plano: {{ item.plan.name }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </v-autocomplete>
                </v-col>
            </template>

            <v-col cols="12">
                <v-text-field
                    autocomplete="nope"
                    v-model="payload.duda_site_name"
                    label="ID do site Duda"
                    outlined
                    hide-details="auto"
                />
            </v-col>

            <v-col
                cols="12"
                v-if="payload.role === 'partner'"
            >
                <v-autocomplete
                    autocomplete="nope"
                    v-model="payload.accesses"
                    label="Acessos"
                    :items="users.filter(user => user.role === 'user')"
                    item-text="name"
                    item-value="_id"
                    multiple
                    outlined
                    hide-details="auto"
                >
                    <template #item="{ item, attrs }">
                        <v-list-item-content v-bind="attrs">
                            <v-list-item-title>{{ item.name }}</v-list-item-title>
                            <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </template>
                    <template #selection="{ item, index }">
                        <div v-if="index === 0">
                            <span>{{ item.name }}</span>
                        </div>
                        <span
                            v-if="index === 1"
                            class="grey--text text-caption"
                        >
                            (+{{ payload.accesses.length - 1 }} outros)
                        </span>
                    </template>
                </v-autocomplete>
            </v-col>
        </v-row>

        <div class="user-tab-panel__actions">
            <v-btn
                color="primary"
                @click="save"
                :loading="saving"
            >
                Salvar
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            saving: false,
            payload: {},
        }
    },
    computed: {
        user: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        users() {
            return this.$store.state.users.data
        },
        subscriptions() {
            return this.$store.state.vindiSubscriptions.data
        },

    },
    methods: {
        async load() {
            const payload = JSON.parse(JSON.stringify(this.value || {}))

            payload.accesses = payload.accesses?.map(access => access.user_id) || []
            payload.geo_seo_prompt_limit = payload.geo_seo_prompt_limit || 1

            this.payload = payload

            if (!this.users.length) {
                await this.$store.dispatch('users/load')
            }

            if (!this.subscriptions.length) {
                await this.$store.dispatch('vindiSubscriptions/load')
            }
        },
        async save() {
            this.saving = true
            const data = JSON.parse(JSON.stringify(this.payload))

            data.accesses = data.accesses || []
            data.accesses = data.accesses.map(access => ({
                user_id: access,
            }))


            const response = await this.$api.updateUser({
                id: this.user._id,
                data
            })

            if (response.error) {
                this.saving = false
                return
            }

            setTimeout(() => {
                this.saving = false
                this.$toast('success', 'Usuário atualizado com sucesso!')
            }, 1000)
        },
    },
    watch: {
        value: {
            immediate: true,
            handler: 'load'
        }
    },

}
</script>

<style scoped>
.user-tab-panel__actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
}
</style>
